import React from 'react';

import { useCheckout } from 'checkout/context';
import useStores from 'shared/hooks/use-stores';
import { CheckoutVariants } from 'src/constants/checkout-variants';

import { OAuthLogin } from '../oauth-login';
import { InternalLogin } from '../internal-login';

export function AccountSection(): JSX.Element {
  const { Cart } = useStores();
  const { variant } = useCheckout();
  const isIsolatedCheckout = variant === CheckoutVariants.isolatedCheckout;
  const enableOmniauthLogin = Cart.dispensary?.storeSettings?.enableOmniauthLoginCheckout ?? false;

  return isIsolatedCheckout && enableOmniauthLogin ? <OAuthLogin /> : <InternalLogin />;
}
